module.exports = __webpack_public_path__ + "img/7. WETLINE, BRUSH.jpg";